/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ControlButton from '../../control/control-button';

/**
 * @private
 * @typedef {import('../../control/control-parser').ControlParser} ControlParser
 */

/**
 * Převaděč informací o ovládání pro standardní webové technologie.
 * @implements {ControlParser}
 */
export default class WebControlParser {
  /** @type {ControlParser['parseKeyCode']} */
  parseKeyCode(keyCode) {
    switch (keyCode) {
      case 13:
        return ControlButton.Enter;
      case 37:
        return ControlButton.ArrowLeft;
      case 38:
        return ControlButton.ArrowUp;
      case 39:
        return ControlButton.ArrowRight;
      case 40:
        return ControlButton.ArrowDown;
      case 54:
      case 102:
        return ControlButton.Digit6;
      case 57:
      case 105:
        return ControlButton.Digit9;
      default:
        return null;
    }
  }
}
